exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{padding-top:70px;display:block}.content-wrapper{margin:40px auto;padding:60px;-webkit-box-shadow:0 10px 25px #e8e8e8;box-shadow:0 10px 25px #e8e8e8;border-radius:10px;border:1px solid #e8e8e8;position:relative;background-color:#fff;max-width:528px;-webkit-box-sizing:border-box;box-sizing:border-box}.content-wrapper.xs{padding:60px 10px}", ""]);

// exports
